import { Link } from 'react-router-dom'
import MobilePanelLeft from '@/assets/claude-sidebar.svg?react'
import SquarePen from '@/assets/note-pencil.svg?react'
import useScrollDirection from '@/hooks/layout/useScrollDirection'
import { useCurrentConversationStore } from '@/store/useCurrentConversationStore'
import { useUIStore } from '@/store/useUIStore'
import { useItemColors } from '@/utils/useItemColors'
import { cn } from '../../lib/utils'

export default function MobileHeader() {
  const scrolledDown = useScrollDirection({ target: '#messages-scroll-area' })
  const toggleSidebar = useUIStore(state => state.toggleSidebar)
  const closeSidebarIfMobile = useUIStore(state => state.closeSidebarIfMobile)
  const isStreaming = useCurrentConversationStore(
    s => s.streamPhase === 'loading' || s.streamPhase === 'streaming',
  )
  const { isNewChat } = useCurrentConversationStore()

  return (
    <div
      id="mobile-header"
      className={cn(
        'h-header pointer-events-none sticky top-0 z-10 flex items-center justify-center *:pointer-events-auto md:hidden',
        '@[84rem]/thread:start-0 @[84rem]/thread:bg-transparent',
        'thread:end-0 bg-background/20',
        isNewChat ? 'absolute end-0 start-0' : 'sticky',
        scrolledDown
          ? '[box-shadow:var(--sharp-edge-top-shadow)]'
          : '[box-shadow:var(--sharp-edge-top-shadow-placeholder)]',
          'flex md:hidden',
          'backdrop-blur-md bg-background/60',
          'border-b border-border/40 new-chat:border-white/10',
      )}
    >
      <div className="absolute inset-y-0 start-0 ms-3 inline-flex items-center justify-center">
        <button
          onClick={toggleSidebar}
          aria-label="Open Sidebar"
          className="inline-flex rounded-md px-2 py-1 text-foreground/80 hover:bg-muted/70 focus:ring-2 focus:ring-inset focus:ring-primary/40 new-chat:text-white/90 new-chat:hover:bg-white/12"
        >
          <MobilePanelLeft className="icon-lg mx-1.5 text-current" />
        </button>
      </div>

      <div className="absolute inset-y-0 end-0 me-3 inline-flex items-center justify-center">
        <span className="flex">
          <Link
            to={isStreaming ? '#' : '/chat'}
            aria-label="New Conversation"
            className={cn(
              'flex size-10 items-center justify-center rounded-lg px-2',
              'transition-colors duration-200',
              isStreaming && 'pointer-events-none opacity-50',
            )}
            onClick={closeSidebarIfMobile}
          >
            <SquarePen className="icon-lg size-[1.3125em]"/>
          </Link>
        </span>
      </div>
    </div>
  )
}
